import { Directive, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import {
  PlanFrequency,
  PlanUniqueId,
  SubscriptionType,
} from "../../../../services/subscription-type/subscription-type.interface";
import { NavigationService } from "src/services/navigation/navigation.service";
import { AuthService } from "src/services/auth/auth.service";
import { SubscriptionTypeService } from "../../../../services/subscription-type/subscription-type.service";
import { CheckoutService } from "src/services/checkout/checkout.service";

import { assertNever } from "src/services/utils/enum.utils";

@Directive()
export abstract class BasePlanCardComponent implements OnInit, OnChanges {
  @Input() public alwaysShowMonthlyPrice: boolean = false;
  @Input() public greyscale: boolean;

  public displayFrequency: string = "-";
  public displayName: string = "-";
  public frequency: PlanFrequency;
  public numberOfPeople: string = "-";
  public planId: PlanUniqueId;
  public price: string;
  public priceWithoutDiscount: string;
  public referralDiscount: number;
  public showActionButton: boolean = true;
  public topologicalLinesAssetFileName: string;

  protected subscriptionType: SubscriptionType | undefined;

  protected constructor(
    protected readonly authService: AuthService,
    protected readonly checkoutService: CheckoutService,
    protected readonly navigationService: NavigationService,
    protected readonly subscriptionTypeService: SubscriptionTypeService,
  ) {}

  public async ngOnInit(): Promise<void> {
    await this.fillPlanInformation();
  }

  public async ngOnChanges(_: SimpleChanges): Promise<void> {
    await this.fillPlanInformation();
  }

  public async goToNextPage(): Promise<void> {
    await this.checkoutService.proceedWithPayment(this.planId, this.frequency);
  }

  protected formatPrice(price: string | number): string {
    const priceNumber = Number(price);
    if (isNaN(priceNumber)) {
      return "-";
    }

    const roundedPrice = Math.round(priceNumber + Number.EPSILON);
    return roundedPrice.toString();
  }

  private async fillPlanInformation(): Promise<void> {
    if (this.alwaysShowMonthlyPrice || this.frequency === PlanFrequency.monthly) {
      this.displayFrequency = "mo";
    } else {
      this.displayFrequency = "year";
    }

    switch (this.planId) {
      case PlanUniqueId.small:
        this.displayName = "Small";
        this.numberOfPeople = "1-2";
        this.topologicalLinesAssetFileName = "corners1.svg";
        break;

      case PlanUniqueId.medium:
        this.displayName = "Medium";
        this.numberOfPeople = "2-4";
        this.topologicalLinesAssetFileName = "corners2.svg";
        break;

      case PlanUniqueId.large:
        this.displayName = "Large";
        this.numberOfPeople = "4-6";
        this.topologicalLinesAssetFileName = "corners3.svg";
        break;

      case PlanUniqueId.individualBootBag:
        this.displayName = "Individual Boot Bag";
        this.numberOfPeople = "1";
        this.topologicalLinesAssetFileName = "corners3.svg";
        break;

      case PlanUniqueId.individualLargeSuitcase:
        this.displayName = "Individual Suitcase";
        this.numberOfPeople = "1";
        this.topologicalLinesAssetFileName = "corners3.svg";
        break;

      case PlanUniqueId.discontinuedDoubleDiamond:
        this.displayName = "X-Large";
        this.numberOfPeople = "6-8";
        this.topologicalLinesAssetFileName = "corners3.svg";
        break;

      default:
        assertNever(this.planId);
    }

    await this.fetchPrice();
  }

  protected abstract fetchPrice(): Promise<void>;
}
